export default function formatShortDate(date: Date): string {
  const threeLetterMonth = date.toLocaleString("default", {
    timeZone: "UTC",
    month: "short",
  });

  return `${threeLetterMonth} ${date.getDate()}`;
}
